var render = function render(){var _vm=this,_c=_vm._self._c;return _c('msg',{staticClass:"employ_msg",attrs:{"config":_vm.config,"type":_vm.type,"promptVisible":_vm.visible,"cancelDialog":_vm.cancelDialogs,"confirmDialog":_vm.tipsConfirm,"isdeling":_vm.isdeling}},[_c('div',[_vm._v(" 提示1 ")]),_c('div',[_vm._v(" 提示2 ")]),_c('div',[_vm._v(" 提示3 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }